module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAACwAgMAAADS2QzNAAAADFBMVEUAAAA3Nzc9PT0zMzMT90ziAAAABHRSTlMAJRkFZn+/BgAAAF9JREFUWMPt1KERwCAMQFHW6iC0S3SdjtZ9iEYlBu6490RiEID47XpbSM7/iZ2d3x07O3uPnZylw6VrlB5Y+zo4iW7oBuiGbsBEN3QDttMN3QDd0A2Y6IZuwHa6saQbA7PGsxCVowZ0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/combinedShape.png
// module id = i9dK
// module chunks = 1